import type { TypesenseClientHandle } from '~/composables/search/useSearchClient'

/** Typesense handle built from public runtime config, regardless of the active engine. */
export const useTypesenseHandle = (): TypesenseClientHandle => {
  const {
    typesenseHost,
    typesensePort,
    typesenseProtocol,
    typesenseSearchApiKey,
  } = useRuntimeConfig().public

  return {
    engine: 'typesense',
    host: `${typesenseProtocol}://${typesenseHost}:${typesensePort}`,
    apiKey: typesenseSearchApiKey ?? '',
  }
}
